/* ==========================================================================
   HOME PASSION - KART UZERINDEN OLCU SECIMI

   Onceden kartlardaki olcu etiketleri (.hp-size) sadece <span> idi:
   dekoratifti, tiklanmiyordu. Musteri 50x50 fiyatini gormek icin urun
   sayfasina girmek zorundaydi.

   Simdi her etiket bir <button> ve uzerinde o olcunun varyant verisi var.
   Tiklaninca sayfa yenilenmeden sunlar guncellenir:
     - fiyat (ve varsa ustu cizili eski fiyat)
     - hizli ekle butonunun varyant kimligi
     - kartin baglantilari  ->  ?variant=... eklenir
     - kart gorseli (o olcunun kendi gorseli varsa)
     - favori butonunun varyant ve fiyat verisi

   Not: linkguard ve surukleme betikleri .hp-size ogesini zaten haric
   tutuyor, yani olcuye basmak urun sayfasina GITMEZ.
   ========================================================================== */
(function(){
  'use strict';
  if(window.__hpCardVariant) return;
  window.__hpCardVariant = 1;

  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.hp-size');
    if(!b) return;

    var card = b.closest('.hp-pc');
    if(!card) return;

    e.preventDefault();
    e.stopPropagation();

    var vid = b.getAttribute('data-vid');
    if(!vid) return;                       /* varyanti bulunamamis etiket */

    /* 1) secili durumu tasi */
    var hepsi = card.querySelectorAll('.hp-size');
    for(var i=0;i<hepsi.length;i++){
      hepsi[i].classList.remove('on');
      hepsi[i].setAttribute('aria-pressed','false');
    }
    b.classList.add('on');
    b.setAttribute('aria-pressed','true');

    /* 2) fiyat */
    var pr = b.getAttribute('data-price');
    var el = card.querySelector('[data-price]');
    if(pr && el){
      el.textContent = pr;
      el.animate(
        [{opacity:.35},{opacity:1}],
        {duration:260, easing:'cubic-bezier(.33,1,.68,1)'}
      );
    }
    var old = b.getAttribute('data-old');
    var oldEl = card.querySelector('del[data-old]');
    if(oldEl){
      if(old){ oldEl.textContent = old; oldEl.hidden = false; }
      else { oldEl.hidden = true; }
    }

    /* 3) hizli ekle butonu */
    var add = card.querySelector('.hp-pc-add');
    var av  = b.getAttribute('data-av') === '1';
    if(add){
      add.setAttribute('data-vid', vid);
      add.disabled = !av;
      add.style.opacity = av ? '' : '.4';
    }

    /* 4) baglantilar */
    var url = b.getAttribute('data-url');
    if(url){
      var links = card.querySelectorAll('a[data-link]');
      for(var j=0;j<links.length;j++){ links[j].setAttribute('href', url); }
    }

    /* 5) gorsel - yalnizca o olcunun kendi gorseli varsa */
    var img = b.getAttribute('data-img');
    var main = card.querySelector('img[data-main]');
    if(img && main && main.getAttribute('src') !== img){
      main.setAttribute('src', img);
      main.classList.add('hp-in');
      main.style.opacity = '1';
    }

    /* 6) favori verisi - dogru varyant kaydedilsin */
    var heart = card.querySelector('[data-wish]');
    if(heart){
      heart.setAttribute('data-wish-vid', vid);
      heart.setAttribute('data-wish-av', av ? '1' : '0');
      if(url) heart.setAttribute('data-wish-url', url);
    }
  }, true);
})();
